import { tokens } from '@cast/design-system';

import { NetworkTrafficBreakdownChartDataKey } from './_types';

export const NETWORK_TRAFFIC_BREAKDOWN_CHART_DATA_SETTINGS: Record<
  NetworkTrafficBreakdownChartDataKey,
  {
    color: string;
    title: string;
    tooltipTitle: string;
  }
> = {
  intraAz: {
    color: tokens.primitives.colors.grey['900'],
    title: 'INTRA-AZ',
    tooltipTitle: 'Intra-AZ',
  },
  crossAz: {
    color: tokens.primitives.colors.blue['300'],
    title: 'CROSS-AZ',
    tooltipTitle: 'Cross-AZ',
  },
  internet: {
    color: tokens.primitives.colors.green['300'],
    title: 'INTERNET',
    tooltipTitle: 'Internet',
  },
  crossRegion: {
    color: tokens.primitives.colors.red['400'],
    title: 'CROSS-REGION',
    tooltipTitle: 'Cross-region',
  },
  cloudApi: {
    color: tokens.primitives.colors.yellow['600'],
    title: 'CLOUD API',
    tooltipTitle: 'Cloud API',
  },
};
